/**
 * Centralized Exam-Style Presets
 * Single source of truth for all preset configurations
 */

export const EXAM_PRESETS = [
  { id: 'necta', name: 'NECTA', icon: '🎓', desc: 'National Exams' },
  { id: 'igcse', name: 'IGCSE', icon: '📚', desc: 'Cambridge' },
  { id: 'college', name: 'College Review', icon: '🏫', desc: 'University Prep' },
  { id: 'kcse', name: 'Kenya KCSE', icon: '🇰🇪', desc: 'Secondary' },
  { id: 'cbse', name: 'India CBSE', icon: '🇮🇳', desc: 'Board Exam' },
  { id: 'jee', name: 'India JEE Prep', icon: '🎯', desc: 'Engineering' },
  { id: 'sat', name: 'US SAT Prep', icon: '🇺🇸', desc: 'College Entry' },
  { id: 'waec', name: 'Nigeria WAEC', icon: '🇳🇬', desc: 'West African' },
  { id: 'ielts-academic', name: 'IELTS Academic', icon: '📖', desc: 'English Test' },
  { id: 'ielts-general', name: 'IELTS General', icon: '✍️', desc: 'English Test' },
  { id: 'caps', name: 'South Africa CAPS', icon: '🇿🇦', desc: 'Curriculum' },
  { id: 'gce', name: 'Cameroon GCE', icon: '🇨🇲', desc: 'General Cert' },
  { id: 'uneb', name: 'Uganda UNEB', icon: '🇺🇬', desc: 'National Exam' },
  { id: 'wassce', name: 'Ghana WASSCE', icon: '🇬🇭', desc: 'West African' },
  { id: 'olevel', name: 'UK O-Level', icon: '🇬🇧', desc: 'British Exam' },
  { id: 'ap', name: 'US AP Exam', icon: '📘', desc: 'Advanced Placement' },
  { id: 'sat-reading', name: 'SAT Reading', icon: '📗', desc: 'Comprehension' },
  { id: 'jamb', name: 'JAMB (UTME)', icon: '🎓', desc: 'Nigeria Uni' },
  { id: 'ielts', name: 'IELTS', icon: '🌍', desc: 'English Test' },
  { id: 'toefl', name: 'TOEFL', icon: '🗽', desc: 'English Test' },
  { id: 'pte', name: 'PTE', icon: '🎤', desc: 'English Test' },
  { id: 'cambridge-english', name: 'Cambridge English', icon: '🏛️', desc: 'Proficiency' },
];

// Quick presets for dashboard (subset of main presets)
export const DASHBOARD_PRESETS = EXAM_PRESETS.filter(p => 
  ['necta', 'igcse', 'college', 'sat', 'ielts', 'toefl'].includes(p.id)
);

// Get preset by ID
export const getPresetById = (id) => EXAM_PRESETS.find(p => p.id === id);

// Default number of questions for preset quizzes
export const PRESET_QUESTION_COUNT = 20;
